import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';

// Website-style boxed row used by the Murphy review section. A light tinted
// background + colored left rail + inline icon, matching the in-app rendering
// in NewAssessmentDetails.jsx. Replaces the earlier "colored dot at left"
// treatment which read as weak/sparse on the PDF page.
const CheckXItem = ({ kind, color, children }) => {
  const isCheck = kind === 'check';
  const railColor = color || (isCheck ? '#21ba45' : '#db2828');
  const bgColor = isCheck ? '#f0fdf4' : '#fef2f2';
  const glyph = isCheck ? '✓' : '!';
  return (
    <View
      wrap={false}
      style={{
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: space.sm,
        backgroundColor: bgColor,
        borderLeftWidth: 3,
        borderLeftColor: railColor,
        borderLeftStyle: 'solid',
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3,
        paddingVertical: 8,
        paddingHorizontal: 10,
      }}
    >
      <Text
        style={{
          color: railColor,
          fontFamily: 'Montserrat',
          fontWeight: 700,
          fontSize: 10,
          marginRight: 6,
          lineHeight: 1.3,
        }}
      >
        {glyph}
      </Text>
      <Text style={[type.body, { color: colors.ink, flex: 1, lineHeight: 1.4 }]}>
        {children}
      </Text>
    </View>
  );
};

export default CheckXItem;
